import { useContext } from 'react';
import { AuthContext } from '../providers';

export enum AppPermissions {
  CLAIM_TRACKING = 'CLAIM_TRACKING',
  CUSTOMERS = 'CUSTOMERS',
  HUDSON_ADJ = 'HUDSON_ADJ',
  SCEORDERS = 'SCEORDERS',
  SCE_REPORTS = 'SCE_REPORTS',
}

export function useUserPermissions() {
  const { userPermissions } = useContext(AuthContext);

  const safePermissions = userPermissions || [];

  const userHasPermission = (permission: string) =>
    ['C_', 'R_', 'U_', 'D_'].some((prefix) => safePermissions.includes(`${prefix}${permission}`));

  return {
    userPermissions: safePermissions,
    userHasPermission,
  };
}

export function useUserHasPermission(permission: string) {
  const { userHasPermission } = useUserPermissions();
  return userHasPermission(permission);
}
